import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import ListUtils from '@/lib/listUtils';
import BookingStatusViewModel from '@/models/Bookings/BookingStatusViewModel';
import BookingStatus from '@/models/Bookings/BookingStatus';

export default class BookingSearchViewModel {
    startAtFrom: string;
    companies: CompanyProfileDto[] = [];
    selectedCompany: CompanyProfileDto;
    locations: LocationProfileDto[] = [];
    selectedLocation: LocationProfileDto;
    branches: BranchDto[] = [];
    selectedBranch: BranchDto;
    statuses: BookingStatusViewModel[] = ListUtils.bookingStatuses();
    selectedStatus: BookingStatus = BookingStatus.Active;
}